export default __webpack_public_path__ + "static/media/creatorHeaderImg.66534018.png";